import React from 'react';
import { ModifyLink } from '@qover/molecules';
import { SummaryHeaderContainer, SummaryCardContainer } from './summary.styles';

type SummaryCardProps = React.PropsWithChildren<{
  modifyTo: string;
  title: JSX.Element;
  'data-test': string;
  style?: React.CSSProperties;
}>;

export const SummaryCard = (props: SummaryCardProps) => (
  <SummaryCardContainer style={props.style}>
    <SummaryHeaderContainer>
      <h2>{props.title}</h2>
      <ModifyLink data-test={props['data-test']} to={props.modifyTo} />
    </SummaryHeaderContainer>
    {props.children}
  </SummaryCardContainer>
);
